import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { flow } from 'lodash';
import { Box, Typography, Button } from '@mui/material';

import {
  getTermsOfUseSections,
  TERMS_OF_USE_TITLE,
  TERMS_OF_USE_UPDATED_AT,
} from '@giro/shared-components/legal/termsOfUse.content';
import ROUTES from '@giro-onboarding/constants/routes.constant';

import onboarding from '@giro-onboarding/store/onboarding';
import apps from '@giro-onboarding/store/apps';

import STEPS, { VARIANTS } from '@giro-onboarding/constants/steps.constant';

import useAuthHook from '@giro/shared-hooks/useAuth.hook';

const termsSections = getTermsOfUseSections(ROUTES.EXTERNAL.PRIVACY_POLICY);

const TermComponent = () => {
  const dispatch = useDispatch();

  const auth = useAuthHook();

  const loadings = {
    loadingOnboarding: useSelector(onboarding.selector.selectLoading),
    loadingApps: useSelector(apps.selector.selectLoading),
  };

  React.useEffect(() => {
    const userChecked =
      auth.user?.user?.checked_email ||
      auth.user?.user?.checked_phone ||
      auth.user?.user?.checked_selfie ||
      auth.user?.user?.checked_document ||
      auth.user?.user?.checked_bgc;

    if (
      userChecked &&
      loadings.loadingApps === false &&
      loadings.loadingOnboarding === false
    ) {
      dispatchRedux.stepNext();
    }
  }, [loadings.loadingApps, loadings.loadingOnboarding]);

  const dispatchRedux = {
    stepNext: flow(onboarding.action.stepNext, dispatch),
    updateVariant: flow(onboarding.action.updateVariant, dispatch),
    updateStep: flow(onboarding.action.updateStep, dispatch),
  };

  const handleAgree = () => {
    dispatchRedux.stepNext();
  };

  const handleDisagree = () => {
    // dispatchRedux.updateVariant(VARIANTS.FINISH.TERM);
    // dispatchRedux.updateStep(STEPS.FINISH);

    (window as any).location.href = process.env.REACT_APP_APP_URL;
  };

  return (
    <Box display="flex" flexDirection="column" gap={6}>
      <Box
        height={400}
        overflow="scroll"
        display="flex"
        flexDirection="column"
        gap={1.5}
      >
        <Box
          position="sticky"
          top={0}
          bgcolor="white"
          boxShadow="0 0 10px 1px #0000000a"
          pb={1}
        >
          <Typography variant="caption" color="primary.main">
            Deslize até o final para ler e aceitar o termo
          </Typography>
        </Box>
        <Box display="flex" flexDirection="column" gap={1.5}>
          <Typography
            variant="body_sm"
            color="grey.500"
            component="div"
            sx={{
              '& p': { my: 2 },
              '& h3': { fontSize: 'inherit', fontWeight: 600 },
              '& a': { color: 'primary.main' },
              '& .policy-table': { overflowX: 'auto' },
              '& table': { width: '100%', borderCollapse: 'collapse' },
              '& th, & td': {
                p: 1,
                textAlign: 'left',
                verticalAlign: 'top',
                borderBottom: '1px solid',
                borderColor: 'divider',
                minWidth: 140,
              },
            }}
          >
            <a
              href={ROUTES.EXTERNAL.TERMS_OF_USE}
              target="_blank"
              rel="noopener noreferrer"
            >
              {TERMS_OF_USE_TITLE}
            </a>
            <br />
            Última atualização:{' '}
            <time dateTime={TERMS_OF_USE_UPDATED_AT.dateTime}>
              {TERMS_OF_USE_UPDATED_AT.label}
            </time>
            .
            {termsSections.map(({ id, title, content }) => (
              <Box component="section" key={id} mt={3}>
                <Typography component="h2" variant="body_sm" fontWeight={700}>
                  {title}
                </Typography>
                {content}
              </Box>
            ))}
          </Typography>
        </Box>
        <Box display="flex" flexDirection="row" gap={2} p={4}>
          <Button variant="outlined" onClick={handleDisagree} fullWidth>
            Não aceito
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleAgree}
            fullWidth
          >
            Aceito
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default TermComponent;
